import type { FC } from 'react'

import { Button } from '@skytech/ui/Button'
import { Link } from 'react-router-dom'

import { useNavBarForCustomer } from '@/app/layout/useNavBarForCustomer'
import { Translation } from '@/app/translations/Translation'
import { APP_ROUTES } from '@/util/app-routes'

import { MenuSubPagesLayout } from './MenuSubPagesLayout'

export const MenuHardware: FC = () => {
  const routes = useNavBarForCustomer()
  if (!routes) throw new Error('No routes found for NavBar!')

  const hardwareNavData = routes.find(route => route.route === APP_ROUTES.HARDWARE_ASSETS)

  return (
    <MenuSubPagesLayout title={<Translation id="Hardware" />}>
      {hardwareNavData?.subRoutes?.map(route => (
        <Link key={route.route} to={route.route}>
          <Button className="mx-0 mb-5 h-auto w-full py-4" Icon={route.Icon}>
            {route.label}
          </Button>
        </Link>
      ))}
    </MenuSubPagesLayout>
  )
}
